import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2b0a1ba0&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=2b0a1ba0&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=2b0a1ba0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a1ba0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0a1ba0')) {
      api.createRecord('2b0a1ba0', component.options)
    } else {
      api.reload('2b0a1ba0', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2b0a1ba0&scoped=true", function () {
      api.rerender('2b0a1ba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/list.vue"
export default component.exports